import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { color } from '../../../styles/helpers/variables';
import { fontFamilyBody } from '../../../styles/helpers/mixins';

class ProductPageDescription extends React.Component {
  constructor(props) {
    super(props);
    this.descriptionRef = React.createRef();
    this.toggleMoreToRead = this.toggleMoreToRead.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.onResize = this.onResize.bind(this);
    this.state = {
      moreToRead: false,
      expanded: false
    };
  }

  componentDidMount() {
    this.toggleMoreToRead();

    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps) {
    if (this.props.description !== prevProps.description) {
      this.toggleMoreToRead();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.setState({ expanded: false });
    this.toggleMoreToRead();
  }

  toggleMoreToRead() {
    const contenteRefCurrent = this.descriptionRef.current;
    if (contenteRefCurrent) {
      this.setState({ moreToRead: contenteRefCurrent.offsetHeight < contenteRefCurrent.scrollHeight });
    }
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { description } = this.props;
    const { moreToRead, expanded } = this.state;

    if (!description) {
      return null;
    }

    return (
      <Description>
        <Paragraph
          expanded={expanded}
          dangerouslySetInnerHTML={{ __html: description }}
          innerRef={this.descriptionRef}
        />
        {moreToRead && (
          <Button type="button" onClick={this.toggleExpanded}>
            {!expanded ? <span>Visa mer</span> : <span>Visa mindre</span>}
          </Button>
        )}
      </Description>
    );
  }
}

ProductPageDescription.defaultProps = {
  description: ''
};

ProductPageDescription.propTypes = {
  description: PropTypes.string
};

export default ProductPageDescription;

const Description = styled.div`
  margin: 0 0 30px;
`;

export const Paragraph = styled.p`
  margin: 0;
  ${fontFamilyBody}
  font-size: 14px;
  font-weight: normal;
  line-height: 1.57;
  color: ${color.black};
  overflow: hidden;
  ${props =>
    !props.expanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    `};
  @media print {
    display: block;
  }
`;

export const Button = styled.button`
  margin: 5px 0 0;
  padding: 0;
  border: none;
  outline: none; // …
  ${fontFamilyBody}
  font-size: 14px;
  font-weight: normal;
  line-height: 1.57;
  color: ${color.black};
  text-decoration: underline;
  cursor: pointer;
  @media print {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/productPage/ProductPageDescription/ProductPageDescription.js